import { render, staticRenderFns } from "./PayDirectlyToClientModal.vue?vue&type=template&id=98347990&"
import script from "./PayDirectlyToClientModal.vue?vue&type=script&lang=js&"
export * from "./PayDirectlyToClientModal.vue?vue&type=script&lang=js&"
import style0 from "./PayDirectlyToClientModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports